import React from "react";
import { getOrgData } from "../../hooks";
import Skeleton from "react-loading-skeleton";

export default function RoleCard({
  isMenuOpen,
  globalUser,
  role,
  eventData,
  isShown,
  ...props
}) {
  const [orgData, setOrgData] = React.useState(undefined);

  React.useEffect(() => {
    async function loadOrgData() {
      let orgResponse = await getOrgData(eventData?.organizationID);

      if (!orgResponse) return;

      setOrgData(orgResponse);
    }

    if (isShown) {
      loadOrgData();
    }
  }, [isShown, eventData]);

  return (
    <>
      {isMenuOpen && isShown ? (
        <div
          className={
            (isMenuOpen ? "opacity-100" : "opacity-0") +
            " flex flex-col justify-between w-full max-w-xs h-fit bg-white border-2 border-gray-100 shadow-[0_8px_24px_rgba(0,0,0,0.1)] rounded-xl z-40 transition-all duration-200 ease-in-out p-4"
          }
          onClick={(e) => e.stopPropagation()}
        >
          <div className="flex flex-col justify-start gap-4">
            <div className="flex flex-col items-start justify-start gap-2">
              {role === "admin" ? (
                <h2 className="text-transparent font-bold text-sm @md:text-sm truncate bg-clip-text bg-gradient-to-r from-red-500 to-pink-500">
                  Event Administrator
                </h2>
              ) : role === "vendoroperator" ? (
                <h2 className="text-transparent font-bold text-sm @md:text-sm truncate bg-clip-text bg-gradient-to-r from-amber-500 to-orange-500">
                  Vendor Operator
                </h2>
              ) : (
                <h2 className="text-transparent font-bold text-sm @md:text-sm truncate bg-clip-text bg-gradient-to-r from-blue-500 to-blue-600">
                  Attendee
                </h2>
              )}
              <div className="flex flex-col gap-0.5">
                <h1 className="text-lg font-bold line-clamp-1 leading-none">
                  {eventData.name}
                </h1>
                <h2 className="text-sm font-normal text-slate-400">
                  {orgData ? (
                    orgData?.organization?.name
                  ) : (
                    <Skeleton className="min-w-[200px]" />
                  )}
                </h2>
              </div>
            </div>

            {/* account button */}
            <a
              href={"/admin/" + eventData?.eventID}
              className="flex flex-col w-full justify-center items-center py-1.5 bg-slate-200 hover:bg-slate-300/80 rounded-lg transition-colors duration-200 ease-in-out"
            >
              <h1 className="text-slate-600 font-medium">
                Event Dashboard
              </h1>
            </a>
          </div>
        </div>
      ) : null}
    </>
  );
}
